import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiOutlineShoppingCart, HiOutlineUser } from "react-icons/hi";
import { MdOutlineExplore } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import { useHistory } from "react-router";
import Logo from "./Logo";
import { getCartCount } from "../../api/apiServices";

const Navbar = () => {
  const location = useLocation();
  const [cartCount, setCartCount] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [colorChange, setColorChange] = useState(true);

  const refreshCartCount = () => {
    getCartCount().then((count) => setCartCount(count));
  };

  useEffect(() => {
    refreshCartCount();
  }, []);

  useEffect(() => {
    if (location.pathname === "/cart") refreshCartCount();
  }, [location.pathname]);

  useEffect(() => {
    const onCartUpdated = () => refreshCartCount();
    window.addEventListener("cartUpdated", onCartUpdated);
    return () => window.removeEventListener("cartUpdated", onCartUpdated);
  }, []);

  const changeNavbarColor = () => {
    if (window.scrollY >= 80) {
      setColorChange(true);
    } else {
      setColorChange(false);
    }
  };
  const history = useHistory();

  useEffect(() => {
    window.addEventListener("scroll", changeNavbarColor);

    return () => {
      window.removeEventListener("scroll", () => { });
    };
  }, []);

  return (
    <nav
      className={`flex flex-col sm:flex-row py-2 sm:py-1 max-w-screen mb-3 fixed left-0 right-0 px-[4%] md:px-[10%] bg-[--theme-color] ${colorChange ? "shadow-sm drop-shadow-sm" : ""
        } z-10 transition delay-75 ease-in-out`}
    >
      <div className="flex justify-between w-full items-center min-h-[44px] sm:min-h-0">
        <section className="relative flex items-center flex-shrink-0">
          <Logo />
        </section>

        <section className="flex items-center flex-wrap justify-end gap-1 sm:gap-2">
          <Link
            to="/search"
            className="flex items-center gap-1.5 px-2 py-2 sm:px-3 sm:py-1.5 rounded-md text-white bg-yellow-700 hover:bg-yellow-800 transition text-sm min-h-[44px] sm:min-h-0 justify-center touch-manipulation"
          >
            <MdSearch className="text-base sm:text-lg flex-shrink-0" />
            <span className="hidden sm:inline">Search Products</span>
          </Link>

          <Link
            to="/products"
            className="flex items-center gap-1.5 px-2 py-2 sm:px-3 sm:py-1.5 rounded-md text-white bg-yellow-700 hover:bg-yellow-800 transition text-sm min-h-[44px] sm:min-h-0 justify-center touch-manipulation"
          >
            <MdOutlineExplore className="text-base sm:text-lg flex-shrink-0" />
            <span className="hidden sm:inline">All Products</span>
          </Link>

          <Link
            to="/account"
            className="flex items-center gap-1.5 px-2 py-2 sm:px-3 sm:py-1.5 rounded-md text-white bg-yellow-700 hover:bg-yellow-800 transition text-sm min-h-[44px] sm:min-h-0 justify-center touch-manipulation"
          >
            <HiOutlineUser className="text-base sm:text-lg flex-shrink-0" />
            <span className="hidden sm:inline">{localStorage.getItem("userId") ? "Account" : "Login"}</span>
          </Link>

          <button
            type="button"
            onClick={() => history.push("/cart")}
            className="relative flex items-center gap-1.5 p-2 sm:p-2 rounded-full bg-yellow-500 text-white hover:bg-yellow-800 transition shadow-sm min-h-[44px] min-w-[44px] sm:min-h-0 sm:min-w-0 sm:px-2 touch-manipulation"
            aria-label={cartCount > 0 ? `Cart (${cartCount} items)` : "Cart"}
          >
            <HiOutlineShoppingCart className="text-base sm:text-lg flex-shrink-0" />
            {cartCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 flex min-w-[18px] h-[18px] items-center justify-center rounded-full bg-red-600 text-[10px] font-semibold text-white shadow-sm px-1">
                {cartCount > 99 ? "99+" : cartCount}
              </span>
            )}
            <span className="hidden sm:inline text-sm">Cart</span>
          </button>
        </section>
      </div>

    </nav>
  );
};

export default Navbar;
